import React, { useState } from "react";
import Study_Program_Card from "../../../../../common_components/common-cards/study-prgram-card/Study_Program_Card";
import Study_Program_Details from "../../../../../common_components/common-cards/study-program-details/Study_Program_Details";
import Applicayion_Study_Program_Details from "../../../../../common_components/common-cards/applicayion_Study_Program_Details/Applicayion_Study_Program_Details";

const Application_Study_Program = ({
  isMyApplications = false,
  onShowDetails,
  onBackToList,
}) => {
  const [selectedProgram, setSelectedProgram] = useState(null);
  const programsData = [
    {
      universityLogo: "/assets/images/common-card/study-program/logo-2.png",
      universityName: "tbs – Toulouse Business School",
      programImage: "/assets/images/common-card/study-program/tbs4.png",
      programName: "Bachelor in Management",
      description:
        "Gain international business exposure with our MBA programs at top global universities combining excellence with real-world experience.",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      duration: "3 Years",
      fees: "27,000",
      feesCurrency: "€",
      documents: [
        { doc: "Travel Insurance" },
        { doc: "Motivation" },
        { doc: "Statement" },
        { doc: "CV" },
      ],
    },
    {
      universityLogo: "/assets/images/common-card/study-program/logo-2.png",
      universityName: "tbs – Toulouse Business School",
      programImage: "/assets/images/common-card/study-program/tbs4.png",
      programName: "Bachelor of Commerce (BCom)",
      description:
        "Gain knowledge and practical skills through our BCom program offered in collaboration with world-class institutions.",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      duration: "4 Years",
      fees: "27,000",
      feesCurrency: "CAD",
      documents: [
        { doc: "Travel Insurance" },
        { doc: "Motivation" },
        { doc: "Statement" },
        { doc: "CV" },
      ],
    },
    {
      universityLogo: "/assets/images/common-card/study-program/logo-2.png",
      universityName: "tbs – Toulouse Business School",
      programImage: "/assets/images/common-card/study-program/tbs4.png",
      programName: "Bachelor of Commerce (BCom)",
      description:
        "Gain knowledge and practical skills through our BCom program offered in collaboration with world-class institutions.",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      duration: "4 Years",
      fees: "118,000",
      feesCurrency: "CAD",
      documents: [
        { doc: "Travel Insurance" },
        { doc: "Motivation" },
        { doc: "Statement" },
        { doc: "CV" },
      ],
    },

    {
      universityLogo: "/assets/images/common-card/study-program/logo-2.png",
      universityName: "tbs – Toulouse Business School",
      programImage: "/assets/images/common-card/study-program/tbs4.png",
      programName: "Bachelor of Commerce (BCom)",
      description:
        "Gain knowledge and practical skills through our BCom program offered in collaboration with world-class institutions.",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      duration: "4 Years",
      fees: "118,000",
      feesCurrency: "CAD",
      documents: [
        { doc: "Travel Insurance" },
        { doc: "Motivation" },
        { doc: "Statement" },
        { doc: "CV" },
      ],
    },
    {
      universityLogo: "/assets/images/common-card/study-program/logo-2.png",
      universityName: "tbs – Toulouse Business School",
      programImage: "/assets/images/common-card/study-program/tbs4.png",
      programName: "Bachelor of Commerce (BCom)",
      description:
        "Gain knowledge and practical skills through our BCom program offered in collaboration with world-class institutions.",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      duration: "4 Years",
      fees: "118,000",
      feesCurrency: "CAD",
      documents: [
        { doc: "Travel Insurance" },
        { doc: "Motivation" },
        { doc: "Statement" },
        { doc: "CV" },
      ],
    },
    {
      universityLogo: "/assets/images/common-card/study-program/logo-2.png",
      universityName: "tbs – Toulouse Business School",
      programImage: "/assets/images/common-card/study-program/tbs4.png",
      programName: "Bachelor of Commerce (BCom)",
      description:
        "Gain knowledge and practical skills through our BCom program offered in collaboration with world-class institutions.",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      duration: "4 Years",
      fees: "118,000",
      feesCurrency: "CAD",
      documents: [
        { doc: "Travel Insurance" },
        { doc: "Motivation" },
        { doc: "Statement" },
        { doc: "CV" },
      ],
    },
  ];

  const handleViewDetails = (program) => {
    setSelectedProgram(program);
    if (onShowDetails) onShowDetails(); // tell parent to hide header
  };

  const handleBack = () => {
    setSelectedProgram(null);
    if (onBackToList) onBackToList(); // tell parent to show header
  };

  return (
    <div className="">
      {/* ================= CARD VIEW ================= */}
      {!selectedProgram && (
        <div className="row g-4 mt-4">
          {programsData.map((program, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12">
              <Study_Program_Card
                {...program}
                showBadge={isMyApplications}
                badgeText="Under Review"
                onViewDetails={() => handleViewDetails(program)}
              />
            </div>
          ))}
        </div>
      )}

      {/* ======================== DETAIL VIEW ====================== */}
      {selectedProgram && (
        <div className="mt-3">
          <Applicayion_Study_Program_Details
            schoolLogo={selectedProgram.universityLogo}
            schoolName={selectedProgram.universityName}
            bannerImg={
              "/assets/images/common-card/detail-card/detail-img-1.png"
            }
            countryFlag={selectedProgram.countryFlag}
            data={selectedProgram}
            onBack={() => setSelectedProgram(null)}
            highlights={[
              "Globally recognized undergraduate degree",
              "Practical learning through case studies and projects",
              "Opportunities for International Internships",
              "Expert faculty and career-focused curriculum",
            ]}
            eligibility={[
              "Completion of high school or equivalent (12th grade)",
              "Valid passport and visa",
              "English or French language proficiency certificate",
            ]}
            careers={[
              "Business Development Executive",
              "Marketing Coordinator",
              "Operations Assistant",
              "Junior Analyst",
              "Management Trainee",
            ]}
            documents={[
              "Academic Transcripts / Certificates",
              "Passport Copy",
              "Resume / CV",
              "Motivation Letter",
            ]}
          />
        </div>
      )}
    </div>
  );
};

export default Application_Study_Program;
